import {ReactNode, useEffect, useRef, useState} from "react";
import {css, cx} from "@panda/css";

import {useAppSelector} from "../../store/hooks";
import {UserSource} from "../../tracking/tracking_utils/user_source";
import {AmplitudeAuthPlacement} from "../../tracking/types/AmplitudeAuthPlacement";
import {IAuthModalVariant} from "../state/auth_modal_slice";
import {AmplitudeAuthLocation, getAmplitudeAuthLocation, trackAmplitudeAuthEvent} from "../tracking/track_amplitude_auth_event";
import {AuthActionType} from "../types/AuthActionType";
import {ExtendedRegisterCard} from "./auth_card/ExtendedRegisterCard";
import {ExtendedRegisterReportCard} from "./auth_card/ExtendedRegisterReportCard";
import {HiddenPriceRegisterCard} from "./auth_card/HiddenPriceRegisterCard";
import {LoginCard} from "./auth_card/LoginCard";
import {RegisterAndDownloadPlanCard} from "./auth_card/RegisterAndDownloadPlanCard";
import {RegisterCard} from "./auth_card/RegisterCard";

interface IProps {
    onAuthSuccess: (authActionType: AuthActionType) => void;
    userSource: UserSource;
    gtmSourceSection?: string;
    modalTitle: ReactNode | string;
    modalDescription?: ReactNode | string;
    gtmEventData?: () => void;
    variant?: IAuthModalVariant;
    className?: string;
    wrapperClassName?: string;
    showLoginForm?: boolean;
    amplitudePlacement?: AmplitudeAuthPlacement | null;
    amplitudeLocation?: AmplitudeAuthLocation;
}

export const AuthCard = (props: IProps) => {
    const {
        variant,
        modalTitle,
        onAuthSuccess,
        userSource,
        className,
        gtmEventData,
        gtmSourceSection,
        modalDescription,
        wrapperClassName,
        showLoginForm = false,
        amplitudePlacement
    } = props;

    const [register, setRegister] = useState(!showLoginForm);
    const loginViewFiredRef = useRef(false);
    const signUpViewFiredRef = useRef(false);
    const currentViewType = useAppSelector((state) => state.viewType.current);
    const amplitudeLocation = props.amplitudeLocation ?? getAmplitudeAuthLocation(currentViewType);

    useEffect(() => {
        if (!register && !loginViewFiredRef.current) {
            loginViewFiredRef.current = true;
            trackAmplitudeAuthEvent("login_form_view", {loginMethod: "internal", loginPlacement: amplitudePlacement ?? null, location: amplitudeLocation});
        } else if (register && !signUpViewFiredRef.current) {
            signUpViewFiredRef.current = true;
            trackAmplitudeAuthEvent("sign_up_form_view", {signUpMethod: "internal", signUpPlacement: amplitudePlacement ?? null, location: amplitudeLocation});
        }
    }, [register]);

    const onToggleAuthForm = () => setRegister((prev) => !prev);

    const RegisterComponent = {
        extended: ExtendedRegisterCard,
        download_report: ExtendedRegisterReportCard,
        hidden_prices_variant_b: HiddenPriceRegisterCard,
        register_and_download_plan: RegisterAndDownloadPlanCard,
        default: RegisterCard
    }[variant ?? "default"];

    return (
        <div className={cx(authCard, className)}>
            {register ? (
                <RegisterComponent
                    onAuthSuccess={onAuthSuccess}
                    onSwitchToLogin={onToggleAuthForm}
                    userSource={userSource}
                    gtmSourceSection={gtmSourceSection}
                    title={modalTitle}
                    description={modalDescription}
                    gtmEventData={gtmEventData}
                    wrapperClassName={wrapperClassName}
                    amplitudePlacement={amplitudePlacement}
                    amplitudeLocation={amplitudeLocation}
                />
            ) : (
                <LoginCard
                    onAuthSuccess={onAuthSuccess}
                    onSwitchToRegister={onToggleAuthForm}
                    userSource={userSource}
                    gtmSourceSection={gtmSourceSection}
                    wrapperClassName={wrapperClassName}
                    amplitudePlacement={amplitudePlacement}
                    amplitudeLocation={amplitudeLocation}
                />
            )}
        </div>
    );
};

const authCard = css({
    width: "100%",

    "@media (min-width: 768px)": {
        width: "456px"
    }
});
import {ReactNode, useEffect, useRef, useState} from "react";
import {css, cx} from "@panda/css";

import {useAppSelector} from "../../store/hooks";
import {UserSource} from "../../tracking/tracking_utils/user_source";
import {AmplitudeAuthPlacement} from "../../tracking/types/AmplitudeAuthPlacement";
import {IAuthModalVariant} from "../state/auth_modal_slice";
import {AmplitudeAuthLocation, getAmplitudeAuthLocation, trackAmplitudeAuthEvent} from "../tracking/track_amplitude_auth_event";
import {AuthActionType} from "../types/AuthActionType";
import {ExtendedRegisterCard} from "./auth_card/ExtendedRegisterCard";
import {ExtendedRegisterReportCard} from "./auth_card/ExtendedRegisterReportCard";
import {HiddenPriceRegisterCard} from "./auth_card/HiddenPriceRegisterCard";
import {LoginCard} from "./auth_card/LoginCard";
import {RegisterAndDownloadPlanCard} from "./auth_card/RegisterAndDownloadPlanCard";
import {RegisterCard} from "./auth_card/RegisterCard";

interface IProps {
    onAuthSuccess: (authActionType: AuthActionType) => void;
    userSource: UserSource;
    gtmSourceSection?: string;
    modalTitle: ReactNode | string;
    modalDescription?: ReactNode | string;
    gtmEventData?: () => void;
    variant?: IAuthModalVariant;
    className?: string;
    wrapperClassName?: string;
    showLoginForm?: boolean;
    amplitudePlacement?: AmplitudeAuthPlacement | null;
    amplitudeLocation?: AmplitudeAuthLocation;
}

export const AuthCard = (props: IProps) => {
    const {
        variant,
        modalTitle,
        onAuthSuccess,
        userSource,
        className,
        gtmEventData,
        gtmSourceSection,
        modalDescription,
        wrapperClassName,
        showLoginForm = false,
        amplitudePlacement
    } = props;

    const [register, setRegister] = useState(!showLoginForm);
    const loginViewFiredRef = useRef(false);
    const signUpViewFiredRef = useRef(false);
    const currentViewType = useAppSelector((state) => state.viewType.current);
    const amplitudeLocation = props.amplitudeLocation ?? getAmplitudeAuthLocation(currentViewType);

    useEffect(() => {
        if (!register && !loginViewFiredRef.current) {
            loginViewFiredRef.current = true;
            trackAmplitudeAuthEvent("login_form_view", {loginMethod: "internal", loginPlacement: amplitudePlacement ?? null, location: amplitudeLocation});
        } else if (register && !signUpViewFiredRef.current) {
            signUpViewFiredRef.current = true;
            trackAmplitudeAuthEvent("sign_up_form_view", {signUpMethod: "internal", signUpPlacement: amplitudePlacement ?? null, location: amplitudeLocation});
        }
    }, [register]);

    const onToggleAuthForm = () => setRegister((prev) => !prev);

    const RegisterComponent = {
        extended: ExtendedRegisterCard,
        download_report: ExtendedRegisterReportCard,
        hidden_prices_variant_b: HiddenPriceRegisterCard,
        register_and_download_plan: RegisterAndDownloadPlanCard,
        default: RegisterCard
    }[variant ?? "default"];

    return (
        <div className={cx(authCard, className)}>
            {register ? (
                <RegisterComponent
                    onAuthSuccess={onAuthSuccess}
                    onSwitchToLogin={onToggleAuthForm}
                    userSource={userSource}
                    gtmSourceSection={gtmSourceSection}
                    title={modalTitle}
                    description={modalDescription}
                    gtmEventData={gtmEventData}
                    wrapperClassName={wrapperClassName}
                    amplitudePlacement={amplitudePlacement}
                    amplitudeLocation={amplitudeLocation}
                />
            ) : (
                <LoginCard
                    onAuthSuccess={onAuthSuccess}
                    onSwitchToRegister={onToggleAuthForm}
                    userSource={userSource}
                    gtmSourceSection={gtmSourceSection}
                    wrapperClassName={wrapperClassName}
                    amplitudePlacement={amplitudePlacement}
                    amplitudeLocation={amplitudeLocation}
                />
            )}
        </div>
    );
};

const authCard = css({
    width: "100%",

    "@media (min-width: 768px)": {
        width: "456px"
    }
});
